import React from "react";
import { isBoolean } from "lodash";
import styled, { css } from "styled-components";
import { Radius, ZIndexes, background, cover } from "@glossy";
import Dots from "@ui-kit/loader/dots";

interface IProps {
  isVisible?: boolean;
  // Show backdrop
  cover?: boolean;
  // Display inline
  inline?: boolean;
  // Dot size
  size?: "s" | "m";
  // Transparent background
  transparent?: boolean;
  className?: string;
}

const Root = styled.div<Partial<IProps>>`
  z-index: ${ZIndexes.Loader};
  pointer-events: none;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 0.5s;
  ${(props) =>
    !props.inline &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `};
  ${(props) =>
    props.cover &&
    css`
      ${cover()};

      :after {
        content: "";
        ${cover()};
        border-radius: ${Radius.MediumLarge};
        opacity: 0.8;
      }
    `};

  :after {
    background-color: ${(props) => !props.transparent && background(props)};
  }
`;

const StyledDots = styled(Dots)`
  position: relative;
  z-index: ${ZIndexes.Content};
`;

const UiKitLoading = React.forwardRef(
  (
    {
      isVisible,
      cover = true,
      inline = false,
      size = "m",
      transparent,
      className,
    }: IProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const _isVisible = isBoolean(isVisible) ? isVisible : true;

    return (
      <Root
        isVisible={_isVisible}
        cover={cover}
        ref={ref}
        inline={inline}
        className={className}
        transparent={transparent}
      >
        {_isVisible && <StyledDots size={size} />}
      </Root>
    );
  }
);

export default UiKitLoading;
